import { Card as AntdCard } from "antd";

import styled from "styled-components";

export const StyledCard = styled(AntdCard)`
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
  max-width: 484px;
  width: 100%;

  .ant-card-body {
    padding: 36px 48px;
  }
`;
